import { SENS_VENTE, MODULE_GESTION_COMMERCIALE } from '@/configuration/devisConf';
import { REGLEMENT } from '@/configuration/mouvementClient/mouvementClientConf';
import moment from 'moment';

export default function genererCritereRechercheJournalReglements() {
  return {
    auto: null,
    societeId: null,
    sensPiece: SENS_VENTE,
    typesPiece: [REGLEMENT],
    dates: {
      dateDebut: (moment().startOf('month')).toDate(),
      dateFin: (moment().endOf('month')).toDate(),
    },
    borneCredit: {
      borneMax: null,
      borneMin: null,
    },
    domiciliationBancaireIds: [],
    referencePaiement: null,
    tiersIds: [],
    compteComptable: null,
    codeFactureOuContrat: null,
    commercialId: null,
    emetteur: null,
    module: MODULE_GESTION_COMMERCIALE,
    modeDeReglementIds: [],
  };
}
